export const faqList = [
  {
    id: 'faq-01',
    question: '蓝莓视频资源更新一般是什么节奏？',
    answer:
      '本站以每日整理为目标，电影多在正片上线后同步记录，剧集与动漫按各自的更新周期整理进度，综艺与纪实类节目按播出期次记录。具体时间会随内容方排期调整，页面的「今日更新」区展示的是最近整理的一批条目。',
  },
  {
    id: 'faq-02',
    question: '怎么快速判断一部作品是不是全集？',
    answer:
      '在「全集与追更专区」里，每张卡片都会显示总集数与当前进度。进度等于总集数的即视为完结，可以连续观看；进度小于总集数的为连载中，卡片备注里会写明大致更新频率。',
  },
  {
    id: 'faq-03',
    question: '热门新片和热度榜有什么区别？',
    answer:
      '「热门新片」更侧重近期上新的作品，并支持按类型筛选，适合想找新内容的人；「热度榜」是按浏览热度排序的前十名，更偏向近期讨论度，适合暂时没有明确目标、想直接挑一部的人。',
  },
  {
    id: 'faq-04',
    question: '页面上的筛选用不了怎么办？',
    answer:
      '筛选与标签切换都是在当前页面对已有条目做即时收窄，不依赖网络请求。如果点击后没有变化，可以先确认当前分类下是否有条目，或刷新页面重试；键盘用户可以用 Tab 定位标签后按回车或空格切换。',
  },
  {
    id: 'faq-05',
    question: '站内条目的简介准确吗？',
    answer:
      '页面中的简介为便于浏览所做的概括整理，用于帮助用户判断类型与看点，可能与内容方的官方介绍表述不同。评分与热度为站内整理口径，仅作参考，不代表任何官方评价。',
  },
  {
    id: 'faq-06',
    question: '为什么有些分类条目比较少？',
    answer:
      '不同题材的产出节奏差异较大，纪实与综艺类的一次更新通常篇幅较长但批次较少，因此条目数量会少于电影和剧集。分类会随着新的整理结果持续补充。',
  },
];